<template>
	<div v-if="(minAmount === undefined || basketData.itemSum >= minAmount) && (basketData.referrerId == referrerId || referrerId === undefined)" class="extra-item">
		<img :src="imgSrc" :alt="imgAlt" />
		<div class="extra-item-content">
			<p>
				{{ itemText }}
			</p>
		</div>
		<div v-if="itemPrice !== undefined" class="extra-item-price-container">
			<p class="extra-sale-price">{{ itemPrice | currency(basketData.currency) }}</p>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: "basket-extra-item",
	props: {
		itemText: {
			type: String,
			required: true
		},
		imgSrc: {
			type: String,
			required: true
		},
		imgAlt: {
			type: String
		},
		itemPrice: {
			type: Number
		},
		referrerId: {
			type: Number
		},
		minAmount: {
			type: Number
		}
	},
	computed: mapState({
		basketData: state => state.basket.data
	})
};
</script>
